import { render, staticRenderFns } from "./ShowAppointmentTeachers.vue?vue&type=template&id=0922961a&scoped=true&"
import script from "./ShowAppointmentTeachers.vue?vue&type=script&lang=js&"
export * from "./ShowAppointmentTeachers.vue?vue&type=script&lang=js&"
import style0 from "./ShowAppointmentTeachers.vue?vue&type=style&index=0&id=0922961a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0922961a",
  null
  
)

export default component.exports